import { createSelector } from 'reselect';
import { PaginationLinksModel } from '@/typings/models/PaginationLinks';

const selectLeadTasksState = (state: DefaultRootState) => state?.leadTasks;

export const selectLeadTasks = createSelector(
  [selectLeadTasksState],
  (leadTasks) => leadTasks?.list || []
);

export const selectLeadTasksOverview = createSelector(
  [selectLeadTasksState],
  (leadTasks) => leadTasks?.overviewList || []
);

export const selectLeadTasksLinks = createSelector(
  [selectLeadTasksState],
  (leadTasks): Partial<PaginationLinksModel> => leadTasks?.links || {}
);

/** The filter set `selectLeadTasksLinks` was fetched for — see the model's `save`. */
export const selectLeadTasksLinksFiltersKey = createSelector(
  [selectLeadTasksState],
  (leadTasks) => leadTasks?.linksFiltersKey || ''
);

export const selectLeadTasksMeta = createSelector(
  [selectLeadTasksState],
  (leadTasks) => leadTasks?.meta || {}
);

export const selectCreateTaskDrawerOpen = createSelector(
  [selectLeadTasksState],
  (leadTasks) => Boolean(leadTasks?.createTaskDrawerOpen)
);

export const selectCreateTaskDrawerTask = createSelector(
  [selectLeadTasksState],
  (leadTasks) => leadTasks?.createTaskDrawerTask
);

export const selectCreateTaskDrawerLeadId = createSelector(
  [selectLeadTasksState],
  (leadTasks) => leadTasks?.createTaskDrawerLeadId
);

export const selectCreateTaskDrawerOnCreated = createSelector(
  [selectLeadTasksState],
  (leadTasks) => leadTasks?.onTaskCreated
);

export const selectCreateTaskDrawerOptions = createSelector(
  [selectLeadTasksState],
  (leadTasks) => leadTasks?.createTaskDrawerOptions,
);

export const selectTaskDetailsDrawer = createSelector(
  [selectLeadTasksState],
  (leadTasks) => leadTasks?.taskDetailsDrawer || {}
);

export const selectTaskDetails = createSelector(
  [selectLeadTasksState, (_: DefaultRootState, taskId?: string) => taskId],
  (leadTasks, taskId) => (taskId ? leadTasks?.taskDetails?.[taskId] : null) || null
);

export const selectAppointmentTasks = createSelector(
  [selectLeadTasksState, (_: DefaultRootState, appointmentId?: string) => appointmentId],
  (leadTasks, appointmentId) => (appointmentId ? leadTasks?.appointmentTasks?.[appointmentId] : undefined)
);
